import {
  setting,
  setting_category,
  setting_category_select,
} from "@Modules/Setting/configs/constants";

import list_setting from "./reducers";
import list_setting_category from "./reducers/category";
import list_setting_category_select from "./reducers/settingSelect";

export default {
  [setting]: list_setting,
  [setting_category]: list_setting_category,
  [setting_category_select]: list_setting_category_select,
};
